<template>
  <div v-if="connector">
    <v-col :align="align" no-gutters>
      <v-card
        class="my-7 border textCard pl-3"
        max-width="280"
        tile
        elevation="0"
        outlined
      >
        Connector {{ connector }}:</v-card
      >
      <Img :value="`${path}/${connector}`" :height="230" />
    </v-col>
  </div>
</template>
<script>
import Img from "../../shared/Img.vue";
export default {
  components: {
    Img,
  },
  props: {
    connector: {
      type: String,
      default() {
        return "";
      },
    },
  },
  data() {
    return {
      path: "connectors",
    };
  },
  computed: {
    align() {
      if (this.$vuetify.breakpoint.width < 1300) {
        return "center";
      } else return "start";
    },
  },
};
</script>


